import type { ReactElement, Ref } from "react";
import { forwardRef } from "react";
import { Slide } from "@mui/material";
import type { TransitionProps } from "@mui/material/transitions";

export const TransitionSlideUp = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement;
  },
  ref: Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const TransitionSlideLeft = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement;
  },
  ref: Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});
